import React, { useState, useEffect } from 'react';
import { useParams } from 'react-router-dom';
import CenteredCircularProgress from '../../../../../lib/designSystem/CircularProgress';
import EnhancedTab from '../../../../../lib/designSystem/TabSimulation';
import LastInvoices from './components/LastInvoices';
import AllInvoices from './components/AllInvoices';

const tabs = [
  {
    id: 1,
    label: 'Transables',
    component: <LastInvoices />,
    path: 'summary',
  },
  {
    id: 2,
    label: 'Todas',
    component: <AllInvoices />,
  },
];

const MyInvoices = () => {
  const { page } = useParams<{
    id: string;
    businessId: string;
    page: string;
  }>();
  const [loading, setLoading] = useState(true);
  const [companyTabs, setCompanyTabs] = useState<any>([]);

  const [startValue, setStartValue] = useState(0);

  const setUpTabs = async () => {
    const newProfileTabs: any = [...tabs];
    let startValueDefault = 0;
    startValueDefault = newProfileTabs.findIndex((x: any) => x.path === page);
    setCompanyTabs(newProfileTabs);
    console.log(newProfileTabs);
    console.log(startValueDefault);
    setStartValue(startValueDefault === -1 ? 0 : startValueDefault);
    setLoading(false);
  };

  useEffect(() => {
    setUpTabs();
  }, []);
  if (loading) return <CenteredCircularProgress />;

  return (
    <div>
      <EnhancedTab
        tabType="secondary"
        startValue={startValue}
        tabs={companyTabs}
        // canShowTab={checkCanAccessView()}
      />
    </div>
  );
};

export default MyInvoices;
